// extracted by mini-css-extract-plugin
module.exports = {"details":"AgentsCategoriesDetails_details__2nGKz"};